const CapitalizedText = ({ text }) => {
    if (!text) return null;
  
    const capitalizeWords = (text) => {
      return text
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    };
  
    return <span>{capitalizeWords(text)}</span>;
  };
  
  export default CapitalizedText;
  